/** @format */

import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BookingDataService } from "../../services/booking-data.service";
import { ConfigurationService } from "../../services/configuration.service";
import { EmpUserService } from "../../services/emp-user.service";
import { HomeDataService } from "../../services/home-data.service";
import { PreferenceDataService } from "../../services/preference-data.service";

@Component({
  selector: "mis-employee-web-exp-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {
  @Input() empGuid: string;
  @Input() buid: string;
  showTeamCalendar = false;
  constructor(
    private user: EmpUserService,
    public configSvc: ConfigurationService,
    private homeSvc: HomeDataService,
    private preferenceSvc: PreferenceDataService,
    private bookingSvc: BookingDataService
  ) {}

  ngOnInit(): void {
    if (!this.empGuid || !this.buid) {
      throw new Error("missing required inputs buid & empGUid");
    }
    this.user.setUser(this.buid, this.empGuid);
    this.configSvc.refreshReplayStreams();
    this.homeSvc.refreshReplayStreams();
    this.preferenceSvc.refreshReplayStreams();
    this.bookingSvc.refreshReplayStreams();
  }

  openTeamCalendar(): void {
    this.showTeamCalendar = true;
  }

  closeTeamCalendar(): void {
    this.showTeamCalendar = false;
  }
}
